import React from "react";
import { Eye } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

export default function DemoBanner() {
  const { user } = useAuth();
  if (!user?.solo_lectura) return null;

  const orgName = user?.organizacion?.nombre || "Demostración";

  return (
    <div
      data-testid="demo-banner"
      className="bg-primary/10 border-b border-primary/20 px-4 py-2 flex items-center justify-center gap-2 text-[13px] text-primary"
    >
      <Eye className="h-4 w-4 shrink-0" strokeWidth={1.75} />
      <span>
        <strong>Modo demostración</strong> — {orgName}: puedes explorar todas las funciones, pero no
        guardar ni modificar datos.
      </span>
    </div>
  );
}
